module.exports = __webpack_public_path__ + "static/media/accurate-advice.622187cb.png";